import React from 'react';

interface CardProps {
  className?: string;
  children?: React.ReactNode;
  sx?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({ className = '', children, sx }) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 ${className}`}
      style={sx}
    >
      {children}
    </div>
  );
};

export default Card;

